import { Autocomplete } from '@mui/material';
import { styled } from '@mui/system';
import { theme } from '../../lib/index';

export const StyledAutocomplete = styled(Autocomplete, {})({
  width: '100%',

  borderRadius: 0,

  '& .MuiAutocomplete-popupIndicatorOpen.MuiButtonBase-root': {
    transform: 'rotate(0deg)',
  },

  '&.Mui-focused': {
    border: 'none',
  },

  '& label.Mui-focused': {
    color: theme.palette.fontgrey,
  },

  '& .MuiOutlinedInput-root': {
    borderRadius: 0,

    '&.Mui-focused fieldset': {
      borderColor: theme.palette.newSecondary,
    },
  },

  '& .MuiAutocomplete-clearIndicator': {
    padding: 0,
  },
});
